// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"db664815358e3fd25485","303":"b7a225f4e36b73c01564","495":"e1a5871f2c30ea40a2b4"}[chunkId] + ".js";
};